/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { PerformanceProgramConfigResponse } from '../models/performance-program-config-response';

/**
 * AMC Performance program configuration.
 */
@Injectable({ providedIn: 'root' })
export class PerformanceProgramsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPerformanceProgramConfig()` */
  static readonly GetPerformanceProgramConfigPath =
    '/api/v1/performance/programs/{code}/config';

  /**
   * Get performance program configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPerformanceProgramConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPerformanceProgramConfig$Response(
    params: {
      code: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<PerformanceProgramConfigResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      PerformanceProgramsService.GetPerformanceProgramConfigPath,
      'get'
    );
    if (params) {
      rb.path('code', params.code, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<PerformanceProgramConfigResponse>;
        })
      );
  }

  /**
   * Get performance program configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPerformanceProgramConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPerformanceProgramConfig(
    params: {
      code: string;
    },
    context?: HttpContext
  ): Observable<PerformanceProgramConfigResponse> {
    return this.getPerformanceProgramConfig$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<PerformanceProgramConfigResponse>
        ): PerformanceProgramConfigResponse => r.body
      )
    );
  }
}
